import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";

function Menu({ collapsed, mobileMenuOpen, setMobileMenuOpen }) {

    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [userData, setUserData] = useState(null);
    const [openMenu, setOpenMenu] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            setUserData(user);
            if (user && user.email) setUsername(user.email);
        });
        return () => unsubscribe();
    }, []);

    const firstLetter = username.charAt(0).toUpperCase();

    const linkStyle = {
        display: "flex",
        alignItems: "center",
        justifyContent:
            isMobile
                ? "flex-start"
                : collapsed
                    ? "center"
                    : "flex-start",

        gap: "12px",
        padding: "14px 18px",
        color: "#fff",
        cursor: "pointer",
        transition: "0.3s"
    };

    const linkHover = {
        background: "rgba(101, 98, 96, 0.62)",
        transform: "translateX(2px)"
    };

    const submenuStyle = {
        paddingLeft: "25px",
        background: "rgba(101, 98, 96, 0.62)",
        borderBottom: "1px solid rgba(255, 255, 254, 0.3)",
        display: "block"
    };

    const iconStyle = { fontSize: "20px", width: "45px", textAlign: "center" };
    const arrowIconStyle = { marginLeft: "auto", transition: "0.3s", fontSize: "14px" };

    const menuItems = [
        {
            icon: "fas fa-home", text: "Home", link: "/home"
        },
        {
            icon: "fas fa-box",
            text: "Master",
            submenu: [
                { text: "Trip Products", link: "/trip-products" },
                { text: "Purchase Products", link: "/purchase-products" },
                { text: "Product Size", link: "/product-size" },
                { text: "Payment Modes", link: "/payment-modes" },
                { text: "Expense Heads", link: "/expense-heads" },
                { text: "Income Heads", link: "/income-heads" },
                { text: "Property Details", link: "/property-details" },
                { text: "Through Details", link: "/through-details" },
            ]
        },
        {
            icon: "fas fa-user-friends",
            text: "Customer",
            submenu: [
                { text: "Customer Mgmt", link: "/customer-mgmt" },
                { text: "Customer Account", link: "/customer-account" },
                { text: "Though Customer Report", link: "/haste-customer-account" },
            ]
        },
        {
            icon: "fas fa-truck",
            text: "Trip",
            submenu: [
                { text: "Add Trip", link: "/add-trip" },
                { text: "View Trip", link: "/view-trip" },
                // { text: "View Bolder Trip", link: "/view-bolder-trip" },
                { text: "Invoice", link: "/trip-invoice" },
                { text: "Quotation", link: "/trip-quotation" },
            ]
        },
        {
            icon: "fas fa-store",
            text: "Dealer",
            submenu: [
                { text: "Dealer Mgmt", link: "/dealer-mgmt" },
                { text: "Dealer Account", link: "/dealer-account" },
            ]
        },
        {
            icon: "fas fa-shopping-cart",
            text: "Purchase",
            submenu: [
                { text: "Add Purchase", link: "/add-purchase" },
                { text: "View Purchase", link: "/view-purchase" }
            ]
        },
        {
            icon: "fas fa-calendar-day",
            text: "Daily I/E",
            submenu: [
                { text: "Daily Other Income", link: "/other-income" },
                { text: "Daily Other Exepnse", link: "/other-expense" },
                { text: "Monthly Split Expense", link: "/split-expense" },
            ]
        },
        {
            icon: "fas fa-calendar",
            text: "Investment",
            submenu: [
                { text: "Pigmi Saving", link: "/pigmi-saving" },
                { text: "RD Saving", link: "/rd-saving" },
            ]
        },
        {
            icon: "fas fa-money",
            text: "Loan Section",
            submenu: [
                // { text: "Loan EMI Expense", link: "/loan-emi-expense" },
                { text: "Add Loan Details", link: "/add-loan" },
            ]
        },

        {
            icon: "fas fa-money-check-alt",
            text: "Payroll",
            submenu: [
                { text: "Staff Mgmt", link: "/staff-mgmt" },
                { text: "Attendance", link: "/attendance" },
                { text: "Advance Payment", link: "/advance-payment" },
                { text: "Monthly Payment", link: "/monthly-payment" },
                { text: "Attendance Report", link: "/attendance-report" },
                { text: "Salary Slip", link: "/salary-slip" },
                { text: "All Staff Salary Slip", link: "/all-staff-salary-slip" },
            ]
        },

        {
            icon: "fas fa-bus",
            text: "Vehical Mgmt",
            submenu: [
                { text: " Vehicles", link: "/vehicle-mgmt" },
                // { text: "Self Vehicles", link: "/self-vehicles" },
                { text: "Fuel Entry", link: "/fuel-entry" },
                // { text: "Average Calculator", link: "/average-calculator" }
            ]
        },

        {
            icon: "fas fa-table",
            text: "Production Mgmt",
            submenu: [
                { text: "Production Vehicals", link: "/production-vehicals" },
                { text: "Bolder Trips", link: "/bolder-trips" },
            ]
        },

        {
            icon: "fas fa-chart-bar",
            text: "Reports",
            submenu: [
                { text: "Sale  Report", link: "/sale-report" },
                { text: "Purchase and Expense Report", link: "/purchase-report" },
                // { text: "Daily Income / Expense", link: "/daily-income-expense" },
                { text: "Customerwise Report", link: "/customerwise-report" },
                { text: "Customer Sale Report", link: "/customer-sale-report" },
                { text: "Outstanding Report", link: "/outstanding-report" },
                { text: "Productwise Report", link: "/productwise-report" },
                { text: "Vehicle Wise Report", link: "/vehiclewise-report" },
                { text: "Paymode Wise Report", link: "/paymodewise-report" },
                { text: "Daily Ledger Report", link: "/daily-ledger-report" },
                { text: "Monthly Report", link: "/monthly-report" },
                { text: "Collection Report", link: "/collection-report" },
                { text: "WhatsApp Report", link: "/whatsapp-history" },
                { text: "Salary Report", link: "/salary-report" },
                { text: "Datewise Customer Outstanding", link: "/datewise-customer-outstanding" },
                { text: "Through Report", link: "/through-report" },
                { text: "Headwise Statement", link: "/headwise-statement" },

            ]
        },

        // {
        //     icon: "fas fa-users-cog",
        //     text: "Users Mgmt",
        //     link: "/users-mgmt"
        // },
    ];

    return (
        <>
            {isMobile && mobileMenuOpen && (
                <div
                    onClick={() => setMobileMenuOpen(false)}
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(0,0,0,.5)",
                        zIndex: 1999
                    }}
                />
            )}
            <aside
                className="main-sidebar"
                style={{
                    background: "linear-gradient(180deg, #13218ce1 0%, #1c1b19 100%)",
                    color: "#fff",
                    height: "100vh",

                    width: isMobile
                        ? "260px"
                        : collapsed
                            ? "80px"
                            : "260px",
                    position: "fixed",
                    top: 0,
                    left: isMobile
                        ? collapsed
                            ? "240px"
                            : "240px"
                        : "0px",
                    transform: isMobile
                        ? mobileMenuOpen
                            ? "translateX(0)"
                            : "translateX(-100%)"
                        : "translateX(0)",

                    transition: "transform 0.3s ease",

                    zIndex: 2000,
                    overflowY: "auto",
                    overflowX: "hidden",

                    boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {/* <div
                    style={{
                        textAlign: "center",
                        borderBottom: "1px solid rgba(255,255,255,0.2)",
                        padding: "15px 10px",
                        position: "sticky",
                        top: 0,
                        background: "rgba(19, 29, 110, 0.89)",
                        backdropFilter: "blur(6px)",
                        zIndex: 10,
                    }}
                >
                    <div
                        style={{
                            width: "60px",
                            height: "60px",
                            borderRadius: "50%",
                            backgroundColor: "rgba(255,255,255,0.2)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "28px",
                            fontWeight: "700",
                            margin: "0 auto 10px auto",
                            color: "#fff",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.3)"
                        }}
                    >
                        A
                    </div>

                    {(!collapsed || isMobile) && (
                        <h5 style={{ fontWeight: "600", margin: 0 }}>
                           ADMIN
                        </h5>
                    )}
                </div> */}

                {/* MENU AREA */}
                <div
                    className="sidebar-scroll"
                    style={{
                        padding: "5px 1px",
                        overflowY: "auto",
                        overflowX: "hidden",
                        flex: 1,
                        height: "calc(100vh - 120px)",
                        paddingBottom: "40px"
                    }}
                >
                    {menuItems.map((item, index) => (
                        <div key={index} style={{ position: "relative" }}>
                            <motion.div
                                onClick={(e) => {
                                    if (item.submenu) {
                                        e.preventDefault();
                                        setOpenMenu(openMenu === index ? null : index);
                                    } else if (item.link) {
                                        navigate(item.link);

                                        if (isMobile) {
                                            setMobileMenuOpen(false);
                                        }
                                    }
                                }}
                                style={linkStyle}
                            // whileHover={linkHover}
                            >
                                <i className={item.icon} style={iconStyle}></i>
                                {(!collapsed || isMobile) && (
                                    <span>{item.text}</span>
                                )}
                                {item.submenu && (!collapsed || isMobile) && (
                                    <i
                                        className="fas fa-chevron-right arrow-icon"
                                        style={{
                                            ...arrowIconStyle,
                                            transform: openMenu === index ? "rotate(90deg)" : "rotate(0deg)"
                                        }}
                                    ></i>
                                )}
                            </motion.div>

                            {item.submenu && openMenu === index && (
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={{ height: "auto", opacity: 1 }}
                                    transition={{ duration: 0.3 }}
                                    style={{ overflow: "hidden" }}
                                >
                                    {item.submenu.map((sub, sIndex) => (
                                        <motion.div
                                            key={sIndex}
                                            onClick={() => {
                                                if (sub.link) {
                                                    navigate(sub.link);

                                                    if (isMobile) {
                                                        setMobileMenuOpen(false);
                                                    }
                                                }
                                            }}
                                            style={{ ...linkStyle, ...submenuStyle, cursor: "pointer" }}
                                            whileHover={linkHover}
                                        >
                                            • {sub.text}
                                        </motion.div>
                                    ))}
                                </motion.div>
                            )}
                        </div>
                    ))}
                </div>
            </aside>
        </>

    );
}

export default Menu;